<template>
  <div class="data-tag">
    <div :class="['tag-color', `${colorClass}`]"></div>
    <div class="tag-content">
      <slot name="tagContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "dataTag",
  props: {
    colorClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.data-tag{
  display: flex;
  flex-direction: row;
  height: 50px;
  width: 100%;
  .tag-color{
    width: 10px;
    //background-color: #abdcff;
  }
  .tag-content{
    width: calc(100% - 10px);
    //border: 1px solid #abdcff;
    border-left: none;
    display: flex;
    justify-content: space-between;
    padding: 8px 14px;
  }
}
.bg-1{
  background-color: #abdcff;
}
.bg-2{
  background-color: #8ce6b0;
}
.bg-3{
  background-color: #ffd77a;
}
.bg-4{
  background-color: #ffb08f;
}
</style>
